import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49996 3.66666C4.03972 3.66666 3.66663 4.03975 3.66663 4.49999V9.49999C3.66663 9.96024 4.03972 10.3333 4.49996 10.3333H6.24996C6.39414 10.3333 6.5313 10.3956 6.62625 10.5041L7.99996 12.074L9.37367 10.5041C9.46862 10.3956 9.60578 10.3333 9.74996 10.3333H11.5C11.9602 10.3333 12.3333 9.96025 12.3333 9.49999V4.49999C12.3333 4.03975 11.9602 3.66666 11.5 3.66666H4.49996ZM2.66663 4.49999C2.66663 3.48747 3.48744 2.66666 4.49996 2.66666H11.5C12.5125 2.66666 13.3333 3.48747 13.3333 4.49999V9.49999C13.3333 10.5125 12.5125 11.3333 11.5 11.3333H9.97684L8.37625 13.1626C8.2813 13.2711 8.14414 13.3333 7.99996 13.3333C7.85578 13.3333 7.71862 13.2711 7.62367 13.1626L6.02308 11.3333H4.49996C3.48744 11.3333 2.66663 10.5125 2.66663 9.49999V4.49999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33329 7.33332C5.33329 6.96518 5.63175 6.66666 5.99996 6.66666C6.36817 6.66666 6.66663 6.96518 6.66663 7.33332C6.66663 7.70147 6.36817 7.99999 5.99996 7.99999C5.63175 7.99999 5.33329 7.70147 5.33329 7.33332Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33329 7.33332C7.33329 6.96516 7.6318 6.66666 7.99996 6.66666C8.36812 6.66666 8.66663 6.96516 8.66663 7.33332C8.66663 7.70148 8.36812 7.99999 7.99996 7.99999C7.6318 7.99999 7.33329 7.70148 7.33329 7.33332Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33329 7.33332C9.33329 6.96516 9.6318 6.66666 9.99996 6.66666C10.3681 6.66666 10.6666 6.96516 10.6666 7.33332C10.6666 7.70148 10.3681 7.99999 9.99996 7.99999C9.6318 7.99999 9.33329 7.70148 9.33329 7.33332Z"
      fill="currentColor"
    />
  </SvgIcon>
));
